exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-default-button[data-v-16141ba8]{border-color:transparent;width:auto}.modal-default-button[data-v-16141ba8]:focus{outline:none}.profile-data[data-v-16141ba8]{cursor:pointer}.profile-data div[data-v-16141ba8]{display:inline-block}img[data-v-16141ba8]{height:1.5rem;width:1.5rem;margin-top:.375rem;margin-left:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-16141ba8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/UserProfileLink.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-16141ba8&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/UserProfileLink.vue
// module chunks = 0